import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import RatingScaleIndexItem from '../RatingScaleIndexItem';
import RatingScaleIconItem from '../RatingScaleIconItem';
import RatingScaleLabelEditorItem from '../RatingScaleLabelEditorItem';
import RatingScaleLabelItem from '../RatingScaleLabelItem';
import styles from './RatingScaleItem.scss';

const RatingScaleItem = ({
  isEditorMode,
  value,
  index,
  indexLabel,
  labelName,
  labelKey,
  labelItem,
  ratingItemClassName,
  indexClassName,
  segmentClassName,
  icon,
  handleChange,
  isItemSelected,
  highlightColorsList,
  labelType,
  enableFillColor,
  startFromZero,
  shouldRenderIndex,
  shouldRenderLabel,
  centerIconVertically = false,
  styleLabel,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const onMouseEnter = (event) => {
    event.preventDefault();
    setIsHovered(true);
  };

  const onMouseLeave = (event) => {
    event.preventDefault();
    setIsHovered(false);
  };

  return (
    <div
      className={cx(
        styles['item-container'],
        isItemSelected && styles['item-selected'],
        !isEditorMode && styles['item-selectable'],
        centerIconVertically && styles['icon-only-item'],
      )}
      style={isHovered || isItemSelected ? { ...highlightColorsList[index] } : {}}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={(event) => {
        handleChange({ event, index, value });
      }}
    >
      <RatingScaleIconItem
        enableFillColor={enableFillColor}
        emptyIcon={icon.empty}
        fullIcon={icon.full}
        containerClassName={styles['icon-item']}
        fullIconContainerClassName={styles['full-icon-item-container']}
      />
      {shouldRenderIndex && (
        <RatingScaleIndexItem
          containerClassName={indexClassName}
          innerClassName={cx(ratingItemClassName, styles['index-item'])}
          indexLabel={indexLabel}
          labelType={labelType}
          startFromZero={startFromZero}
        />
      )}
      {shouldRenderLabel &&
        (isEditorMode ? (
          <RatingScaleLabelEditorItem
            index={index}
            labelKey={labelKey}
            labelName={labelName}
            containerClassName={cx(segmentClassName, styles['label-item'])}
            labelClassName={ratingItemClassName}
            styleLabel={styleLabel}
          />
        ) : (
          <RatingScaleLabelItem
            containerClassName={cx(segmentClassName, styles['label-item'])}
            labelClassName={cx(ratingItemClassName, styles['label-item-readonly'])}
            labelItem={labelItem}
            styleLabel={styleLabel}
          />
        ))}
    </div>
  );
};

RatingScaleItem.propTypes = {
  isEditorMode: PropTypes.bool,
  value: PropTypes.number,
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  indexLabel: PropTypes.number,
  labelName: PropTypes.string,
  labelKey: PropTypes.string,
  labelItem: PropTypes.object,
  ratingItemClassName: PropTypes.string,
  indexClassName: PropTypes.string,
  segmentClassName: PropTypes.string,
  labelType: PropTypes.string,
  enableFillColor: PropTypes.bool,
  highlightColorsList: PropTypes.array,
  startFromZero: PropTypes.bool,
  icon: PropTypes.shape({
    empty: PropTypes.object,
    full: PropTypes.object,
  }).isRequired,
  handleChange: PropTypes.func,
  isItemSelected: PropTypes.bool,
  styleLabel: PropTypes.object,
  centerIconVertically: PropTypes.bool,
  shouldRenderIndex: PropTypes.bool,
  shouldRenderLabel: PropTypes.bool,
};

export default RatingScaleItem;
